import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

interface PlatoHourglassProps {
  size?: number;
  title?: string;
}

function PlatoHourglass({ size = 12, title }: PlatoHourglassProps) {
  return (
    <Styled.Wrapper title={title}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        role={title ? "img" : "presentation"}
        aria-hidden={title ? undefined : true}
      >
        {title && <title>{title}</title>}
        <path d="M5 22h14" />
        <path d="M5 2h14" />
        <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
        <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
      </svg>
    </Styled.Wrapper>
  );
}

export default PlatoHourglass;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Wrapper = styled.span((props: any) => {
  const t: any = props.theme;
  return css`
    label: PlatoHourglass;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    color: ${t.dark ? t.color.gray[500] : t.color.gray[400]};
    svg {
      display: block;
    }
  `;
});
